ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
MemberList = undefined
queueRequire -> MemberList = require 'models/collections/member-list'
OrganizationList = undefined
queueRequire -> OrganizationList = require 'models/collections/organization-list'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
ModelWithPreferences = require 'models/internal/model-with-preferences'
Organization  = require 'models/organization'
Promise = require 'bluebird'
_ = require 'underscore'
OrgFeatures = require 'data/org-features'

module.exports = class Enterprise extends ModelWithPreferences
  typeName: 'Enterprise'
  nameAttr: 'name'
  urlRoot: '/1/enterprises'

  initialize: ->
    super
    @attemptedToLoadUserTypes = false
    @destruct [
      @organizationList = new OrganizationList().syncModel(@, 'idOrganizations')
      @memberList = new MemberList()
    ]

  loadPageOfMembers: (query) ->
    ModelLoader.loadMembersOfEnterprise(@get('name'), query)
    .tap ([members]) =>
      @memberList.add(members) if members.length > 0

  loadUserTypes: ->
    ModelLoader.loadEnterprise @id,
      fields: 'userTypes'
      organizations: 'none'
    # This is currently slow for big enterprises. Swallow timeouts, and you'll
    # need to render the UI as best as you can.
    .catch ApiError.Server, (err) ->
      if err.message != "Gateway Timeout"
        throw err
    .tap =>
      @attemptedToLoadUserTypes = true

  loadJoinRequests: ->
    ModelLoader.loadEnterprise @id,
      # load prefs to refresh maxMembers
      fields: 'joinRequests,prefs'
      organizations: 'none'

  # This is silly, but the enterprises endpoint serves more than actual
  # enterprises. There there's also other "collections of teams" that we use to
  # configure sso and for recurring billing. This is how we tell if something
  # from that endpoint is actually an enterprise:
  isRealEnterprise: ->
    OrgFeatures.isFeatureEnabled('enterpriseUI', @get('products'))

  _removeJoinRequestFromAttrs: (idOrg) ->
    oldJoinRequests = @get('joinRequests')
    newJoinRequests = _.filter oldJoinRequests, (joinRequest) ->
      joinRequest.organization.id != idOrg
    @set('joinRequests', newJoinRequests)

  declineJoinRequest: (joinRequest) ->
    # This is the same as org.cancelEnterpriseJoinRequest, but we can't invoke
    # that from here because the enterprise admin might not have permission to
    # access the org and therefore we might not have the org as a backbone
    # model.
    ApiPromise
      url: "/1/organizations/#{ joinRequest.organization.id }/enterpriseJoinRequest"
      type: 'DELETE'
    .then =>
      @_removeJoinRequestFromAttrs(joinRequest.organization.id)

  acceptJoinRequest: (joinRequest) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/organizations"
      type: 'PUT'
      data:
        idOrganization: joinRequest.organization.id
    .then (teamPayloads) =>
      @_removeJoinRequestFromAttrs(joinRequest.organization.id)

      teamPayload = _.find teamPayloads, (teamPayload) ->
        teamPayload.id == joinRequest.organization.id

      team = @modelCache.get('Organization', joinRequest.organization.id)
      if !team?
        team = new Organization(teamPayload, modelCache: @modelCache)
      else
        team.set(teamPayload)

      @organizationList.add(team)

  getAvailableLicenses: ->
    return unless @get('userTypes')?

    if @getPref('maxMembers')?
      @getPref('maxMembers') - @get('userTypes').member
    else
      Infinity



// WEBPACK FOOTER //
// ./app/scripts/models/enterprise.coffee